import { InfiniteData } from 'react-query';
import produce from 'immer';

import { queryClient } from '@/utils';
import type { FeedArticleDetail } from '@/views/Stream/types';

export const CHANNEL_STREAM_LIST_PREFIX = 'CHANNEL_STREAM_LIST';

export const setChannelStreamListQuery = (
  id: number,
  currentAddress: string,
  recipe: (article: FeedArticleDetail) => void,
) => {
  queryClient.setQueriesData<InfiniteData<Record<string, FeedArticleDetail[]>> | undefined>(
    [CHANNEL_STREAM_LIST_PREFIX, currentAddress],
    pre => {
      // 不存在这个列表的时候，直接返回了
      if (!pre) {
        return pre;
      }

      return produce(pre, draft => {
        // 使用 find 提前退出循环
        draft.pages.find(x => {
          const record = x.articles?.find((p: FeedArticleDetail) => p.article.id === id);

          if (record) {
            recipe(record);

            return true;
          }

          return false;
        });

        return draft;
      });
    },
  );
};

export const setChannelStreamQuoteListQuery = (
  id: number,
  currentAddress: string,
  recipe: (article: FeedArticleDetail) => void,
) => {
  queryClient.setQueriesData<InfiniteData<Record<string, FeedArticleDetail[]>> | undefined>(
    [CHANNEL_STREAM_LIST_PREFIX, currentAddress],
    pre => {
      // 不存在这个列表的时候，直接返回了
      if (!pre) {
        return pre;
      }

      return produce(pre, draft => {
        draft.pages.forEach(x => {
          x.articles
            ?.filter((p: FeedArticleDetail) => p.article.quote_article?.id === id)
            .forEach(record => {
              recipe({ article: record.article.quote_article! });
            });
        });

        return draft;
      });
    },
  );
};

export const invalidateChannelStreamList = (currentId: string, id: string, type?: string) => {
  const key = [CHANNEL_STREAM_LIST_PREFIX, currentId, id];

  queryClient.invalidateQueries(type ? key.concat(type) : key);
};
